import { render, staticRenderFns } from "./KDrawer.vue?vue&type=template&id=2e9866c6&scoped=true&lang=pug&"
import script from "./KDrawer.vue?vue&type=script&lang=ts&"
export * from "./KDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./KDrawer.vue?vue&type=style&index=0&id=2e9866c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9866c6",
  null
  
)

export default component.exports